import React from 'react';
import { FadeIn } from './FadeIn';
export function StepsSection() {
  const steps = [{
    num: '1',
    title: 'Descarga y Limpia',
    desc: "Descarga el manual y localiza los 5 'Falsos Amigos' en tu cocina para eliminarlos."
  }, {
    num: '2',
    title: 'Resetea',
    desc: "Inicia cada mañana con el 'Suero Maestro' para resetear tus glándulas suprarrenales."
  }, {
    num: '3',
    title: 'Repara',
    desc: 'Sigue el menú de reparación celular durante 10 días y registra cómo tu energía sube mientras tu inflamación baja.'
  }];
  return <section className="py-24 bg-cream" data-id="element-183">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-forest mb-16" data-id="element-186">
            ¿Cómo funciona?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-187">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-emerald/20 z-0" data-id="element-188" />

          {steps.map((step, idx) => <FadeIn key={idx} delay={0.2 * idx} className="relative z-10 text-center" data-id="element-189">
              <div className="w-24 h-24 mx-auto bg-white border-4 border-emerald rounded-full flex items-center justify-center mb-6 shadow-lg" data-id="element-190">
                <span className="text-3xl font-bold text-forest" data-id="element-191">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl font-bold text-forest mb-3" data-id="element-192">
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-193">
                {step.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}